import { Injectable, Inject } from "@angular/core";
import { Subscription, timer, Subject, Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { DialogService } from "./dialog.service";
import { differenceInMinutes } from "date-fns";
import { MsalService } from "@azure/msal-angular";

@Injectable({
  providedIn: "root",
})
export class TimeOutService {
  private timeCounter: Subscription;
  private lastActivity: Date;
  private readonly tickIntervalInSec = 30;
  private readonly timeoutMinutes = 30;
  timeOut = new Subject<boolean>();

  constructor(
    private router: Router,
    private msalService: MsalService,
    private dialogService: DialogService,
    private authservice: AuthService
  ) {
    this.RouteWatch();
  }

  private RouteWatch() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updatelatestUserActivity();
      });
  }

  private startTimer() {
    this.timeCounter = timer(0, this.tickIntervalInSec * 1000).subscribe(
      (t) => {
        const diffInMin = differenceInMinutes(new Date(), this.lastActivity);
        if (diffInMin > this.timeoutMinutes) {
          this.handleTimeOut();
          this.timeCounter.unsubscribe();
          return;
        }
      }
    );
  }

  updatelatestUserActivity() {
    this.lastActivity = new Date();
  }

  initActivity() {
    this.updatelatestUserActivity();
    this.startTimer();
  }

  handleTimeOut() {
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (!!activeAccount) {
     this.dialogService.showTimeoutWindow().then(resp => {
       this.initActivity();
     }, dismiss => {
       this.authservice.logout();
     });
    }
  }
}

@Injectable()
export class TimerInterceptor implements HttpInterceptor {
  constructor(private timerservice: TimeOutService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.timerservice.updatelatestUserActivity();
    return next.handle(request);
  }
}
